import { IEmptyResult } from '../types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from './Request';

export interface ISetDatasourceRemoteQueryAgentParams extends IIdItem {
  remoteAgentName: string;
  // Determines what it means when remoteAgentName is null/not present.
  // If true, remoting live connections through this data source remains enabled.
  useDefaultAgent: boolean;
}

export class SetDatasourceRemoteQueryAgentRequest extends Request<ISetDatasourceRemoteQueryAgentParams,
    IEmptyResult> {
  constructor(params: ISetDatasourceRemoteQueryAgentParams) {
    super('setDatasourceRemoteQueryAgent', params);
  }
}
